export enum DocumentEvents {
    VisibilityChange = 'visibilitychange'
}
